module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pc-header', {
    staticClass: "pc-show"
  }), _vm._v(" "), _c('phone-header', {
    staticClass: "phone-show"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('phone-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerFixed),
      expression: "headerFixed"
    }],
    staticClass: "transition-header phone-show"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4520009f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/userCenterHeader/Index.vue
// module id = 1310
// module chunks = 1